import {
  Box,
  Button,
  Flex,
  Skeleton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import Layout from "../components/Layout";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import client from "../utils/client";
import NewsItem from "../components/NewsItem";
import AdminPage from "../components/AdminPage";

const AllNews = () => {
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const [newsItems, setNewsItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState([]);

  const auth = useAuth();
  const navigate = useNavigate();

  const isAdmin = auth?.user?.type === process.env.REACT_APP_ADMINISTRATOR;
  const isNewsAuthor = auth?.user?.type === process.env.REACT_APP_NEWS;

  const handleDelete = async (newsId) => {
    await client.delete(`/news/${newsId}`);
    setNewsItems((prev) => prev.filter((n) => n.newsId !== newsId));
  };

  useEffect(() => {
    setIsLoadingPage(true);
    const request = async () => {
      const response = await client.get(`/news?page=${currentPage}`);
      let items = response.data.newsItems;
      if (isNewsAuthor && !isAdmin) {
        items = items.filter((n) => n.authorId === auth.user.id);
      }
      setNewsItems(items);
      setCurrentPage(response.data.currentPage);
      setTotalPages(
        Array.from({ length: response.data.totalPages }, (_, i) => i + 1)
      );
    };
    request().then(() => setIsLoadingPage(false));
  }, [currentPage, isAdmin, isNewsAuthor, auth.user.id]);

  return (
    <Layout>
      {isAdmin || isNewsAuthor ? (
        <AdminPage
          title={isAdmin ? "Gerenciar Notícias" : "Minhas Notícias"}
          subtitle={`${newsItems.length} ${newsItems.length === 1 ? "notícia" : "notícias"}`}
          action={() => navigate("/createNews")}
          actionLabel="+ Nova Notícia"
        >
          <Skeleton isLoaded={!isLoadingPage}>
            <TableContainer>
              <Table size="sm" variant="striped" colorScheme="green" fontSize="0.82rem">
                <Thead bg="green.50">
                  <Tr>
                    <Th fontSize="0.72rem" maxW="220px">Título</Th>
                    <Th fontSize="0.72rem">Data</Th>
                    <Th fontSize="0.72rem">Autor</Th>
                    <Th fontSize="0.72rem">Ações</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {newsItems.length === 0 && !isLoadingPage && (
                    <Tr>
                      <Td colSpan={4}>
                        <Box textAlign="center" py={8} color="gray.400">
                          <Text>Nenhuma notícia encontrada.</Text>
                        </Box>
                      </Td>
                    </Tr>
                  )}
                  {newsItems.map((news) => {
                    const isOwner = news.authorId === auth.user.id;
                    return (
                      <NewsItem
                        key={news.newsId}
                        news={news}
                        onDelete={handleDelete}
                        canEdit={isAdmin || isOwner}
                        canDelete={isAdmin || isOwner}
                      />
                    );
                  })}
                </Tbody>
              </Table>
            </TableContainer>

            {isAdmin && totalPages.length > 1 && (
              <Flex gap={2} py={4} px={5} alignItems="center" justifyContent="center">
                {totalPages.map((page) =>
                  page === currentPage ? (
                    <Box
                      key={page}
                      w="32px" h="32px"
                      borderRadius="50%"
                      bg="green.500"
                      color="white"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      fontWeight={700}
                      fontSize="0.85rem"
                    >
                      {page}
                    </Box>
                  ) : (
                    <Button
                      key={page}
                      colorScheme="green"
                      size="sm"
                      variant="outline"
                      borderRadius="50%"
                      w="32px" h="32px"
                      p={0}
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </Button>
                  )
                )}
              </Flex>
            )}
          </Skeleton>
        </AdminPage>
      ) : (
        <Box textAlign="center" py={20} color="gray.400">
          <Text fontSize="1.2rem">Acesso não autorizado.</Text>
        </Box>
      )}
    </Layout>
  );
};
export default AllNews;
